var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 51,
    rx: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7804 33.7237C22.7191 31.4184 17.0947 27.1085 15.7186 25.8681C14.372 24.6543 13.0838 21.5457 13.4863 18.238",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2798 28.7565C32.3243 27.6539 30.9867 24.3768 33.2798 20.0884",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0151 15.4274C28.0277 15.3205 30.3656 14.3188 31.6158 11.1678",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5119 21.3868C23.6389 21.3868 20.5672 19.6926 19.6682 18.0754",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9783 27.3669C14.8939 27.5372 10.304 26.9343 8.6198 23.16",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.015 40.1154C26.3364 35.6615 24.3384 27.9447 24.9793 24.3344C25.6202 20.7241 27.8067 12.3497 24.9793 9",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4622 36.1584C27.6964 33.941 31.0905 29.2767 34.7931 28.3592C38.4957 27.4416 39.8071 21.554 39.9999 18.7249",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6708 36.8489C35.9051 39.0817 31.5043 40.3643 26.8026 40.3643C21.9685 40.3643 17.4526 39.0085 13.6179 36.6582",
    stroke: "#EA6C52",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/iconBox.db06c606548bbfa0bbf2ee1bee6297d0.svg";
export { ForwardRef as ReactComponent };